import { Component, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { CookieConsentService } from '../../services/cookie-consent.service';
import { HttpService } from '../../services/http-service';
import { ITranslation } from '../../models/translations/translations';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-cookie-consent-banner',
  templateUrl: './cookie-consent-banner.component.html',
  styleUrls: ['./cookie-consent-banner.component.scss']
})
export class CookieConsentBannerComponent implements OnInit, OnDestroy {
  showBanner = false;
  private translationSubscription: Subscription;

  constructor(
    private consentService: CookieConsentService,
    public httpService: HttpService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  get t(): ITranslation {
    return this.httpService.getTransation();
  }

  ngOnInit(): void {
    // Show banner if consent is required
    this.showBanner = this.consentService.shouldShowBanner();

    if (this.showBanner) {
      console.log('[CookieConsentBanner] Showing consent banner for EU user');
    }

    // Listen for translation changes (when user logs in and language is detected)
    this.translationSubscription = this.httpService.onTranslationChanged.subscribe((translation) => {
      console.log('[CookieConsentBanner] Translation changed, triggering change detection');
      // Trigger change detection to update the banner text
      this.changeDetectorRef.detectChanges();
    });
  }

  ngOnDestroy(): void {
    if (this.translationSubscription) {
      this.translationSubscription.unsubscribe();
    }
  }

  onAccept(): void {
    this.consentService.grantConsent();
    this.showBanner = false;
  }

  onDecline(): void {
    this.consentService.denyConsent();
    this.showBanner = false;
  }
}

